/**
 * @desc 获取跳转链接
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** coupon_code */
  coupon_code: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.LinkedUrl>>(
    `/storeapi/inner/jump/link`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.LinkedUrl>;
export default req;
